/* VitaFresh Warenkorb-Basis (20.10.2026), lädt im Kopf vor allen Warenkorb-Skripten (snippets/vf-kuehltasche.liquid),
   Daten aus snippets/vf-rabatt-daten.liquid.
   1. Rabattstufen aus einer Quelle: Metaobjekte «Rabattstufe» (vf_rabattstufe) im Admin, ausgegeben als JSON #vf-rabatt-daten.
      Rabatt-Balken (assets/vf-rabatt-balken.js) und Gericht-Vorschläge (assets/vf-warenkorb-logik.js) lesen nur noch von hier.
      Die Rabatte selbst rechnet Shopify aus den automatischen Rabatten; die Metaobjekte sagen nur, was der Shop anzeigt.
      Fehlt das Snippet, gelten die bisherigen Werte (Gratis ab 100, 10/12/15 % ab 150/200/300); sind die Einträge im Admin
      halb gepflegt, zeigt der Warenkorb keine Stufen (lieber keine als falsche).
   2. Ein Abruf von /cart.js je Warenkorb-Stand: Alle Skripte bekommen dieselbe Antwort (je eine eigene Kopie), bis sich der
      Warenkorb ändert (Meldung oder Änderungs-Aufruf, siehe unten) oder sie älter als 2 s ist. Abrufe, die frisch sein müssen
      (Zur Kasse), gehen weiter direkt an Shopify.
   3. Angezeigte Artikelzahl ohne Kühltasche (anzeigeAnzahl, Pasci 21.10.2026): Kopfzähler, Titel des Mini-Warenkorbs, Kasse-Balken.
      Liquid rechnet dasselbe in snippets/vf-korb-anzahl.liquid. Entscheidungen («leer oder nicht», passtZurListe) bleiben bei item_count.
   Tests: tests/vf-warenkorb-basis.test.js */
(function (root) {
  "use strict";
  /* Eingebunden nur im Kopf über snippets/vf-kuehltasche.liquid (seit 28.10.2026). Die Sperre bleibt: lädt ein Layout die Datei doch zweimal, zählt nur die erste Instanz. */
  if (typeof module === "undefined" && root.VFWarenkorbBasis) return;

  var STANDARD = {
    gratis: 100,
    stufen: [{ ab: 150, prozent: 10, titel: "10%" }, { ab: 200, prozent: 12, titel: "2%" }, { ab: 300, prozent: 15, titel: "3%" }]
  };

  function ganz(v) { var n = Number(v); return isFinite(n) && n > 0 && Math.round(n) === n ? n : 0; }

  /* Rohdaten (aus dem JSON) prüfen und ordnen. Keine Daten (Snippet fehlt): STANDARD. Daten da, aber nicht ganz gültig
     (halb gepflegt, alles deaktiviert, doppelte Titel, Stufe unter der Gratis-Grenze): null, dann zeigt der Warenkorb keine
     Stufen statt falscher (Prüfung 20.10.2026). Nie halbe Stufen. */
  function aus(daten) {
    if (daten == null) return mitTiteln(STANDARD, true);
    var d = daten;
    var gratis = ganz(d.gratis);
    var stufen = (Array.isArray(d.stufen) ? d.stufen : []).map(function (s) {
      return { ab: ganz(s && s.ab), prozent: ganz(s && s.prozent), titel: String((s && s.titel) || "").replace(/\s+/g, "") };
    }).sort(function (a, b) { return a.ab - b.ab; });
    var gesehen = {};
    var ok = gratis > 0 && stufen.length > 0 && stufen[0].ab > gratis && stufen.every(function (s, i) {
      var neu = s.titel && !gesehen[s.titel];
      gesehen[s.titel] = true;
      return neu && s.ab > 0 && s.prozent > 0 && s.prozent < 100 && (i === 0 || (s.ab > stufen[i - 1].ab && s.prozent > stufen[i - 1].prozent));
    });
    return ok ? mitTiteln({ gratis: gratis, stufen: stufen }, false) : null;
  }
  /* Jede Stufe ist ein eigener automatischer Rabatt; sie addieren sich: Titel → Zuwachs in Prozentpunkten */
  function mitTiteln(r, standard) {
    var titel = {};
    r.stufen.forEach(function (s, i) { titel[s.titel] = s.prozent - (i ? r.stufen[i - 1].prozent : 0); });
    return { gratis: r.gratis, stufen: r.stufen.slice(), titel: titel, standard: standard };
  }

  var stufenCache, gelesen = false;
  function lesen() {
    if (gelesen) return stufenCache;
    var daten = null;
    var doc = root.document, el = doc && doc.getElementById("vf-rabatt-daten");
    try { daten = el ? JSON.parse(el.textContent) : null; } catch (e) { daten = {}; /* kaputtes JSON: ungültig, nicht Standard */ }
    var k = aus(daten);
    /* Noch im Seitenaufbau und das JSON (Ende der Seite) fehlt: nicht merken, beim nächsten Mal nochmals lesen */
    if (el || !doc || doc.readyState !== "loading") { stufenCache = k; gelesen = true; }
    return k;
  }

  /* ---------- Ein Abruf je Warenkorb-Stand ---------- */
  /* Die Bausteine fragen mit eigenen Verzögerungen (0,4–1 s nach einer Meldung), also selten gleichzeitig. Darum gilt eine Antwort
     für alle, solange der Warenkorb sich nicht geändert haben kann: höchstens FRISCH_MS, und nie über eine Änderung hinweg.
     Eine Änderung ist jede Meldung (cart-updated) und jeder Aufruf von /cart/add, /change, /update oder /clear über fetch,
     egal von welchem Skript (Theme, Kühltasche, Liefertermin, Konto …): vor und nach dem Aufruf beginnt ein neuer Stand. */
  var FRISCH_MS = 2000, HAENGT_MS = 8000; /* ein Abruf ohne Antwort nach 8 s: neu fragen statt alle warten lassen */
  var generation = 0, letzter = null, offen = 0, letzteAenderung = 0;
  var holeRoh = root.fetch ? root.fetch.bind(root) : null;
  function geaendert() { generation++; }
  /* /cart/change, /update und /clear antworten mit dem ganzen Warenkorb (wie /cart.js). Diese Antwort gilt als neuer Stand,
     dann braucht nach einer Mengenänderung kein Baustein mehr /cart.js und der Rabatt-Balken zeichnet mit der Liste (Pasci 21.10.2026:
     Balken kam 0,1–0,2 s nach der Summe). Nur die Antwort der zuletzt gesendeten Änderung und nur, wenn keine andere mehr läuft:
     sonst könnte eine ältere Antwort einen neueren Stand überdecken. /cart/add antwortet nur mit den neuen Zeilen. */
  function saeen(c) { letzter = { gen: generation, zeit: Date.now(), fertig: true, saat: true, daten: c, p: Promise.resolve(c) }; }
  if (holeRoh && typeof module === "undefined") {
    root.fetch = function (eingabe) {
      var url = String((eingabe && eingabe.url) || eingabe || ""); /* Text, URL-Objekt oder Request */
      var m = url.match(/(^|\/)cart\/(add|change|update|clear)(\.js)?(\?|#|$)/);
      if (!m) return holeRoh.apply(null, arguments);
      geaendert(); offen++;
      var nr = ++letzteAenderung;
      var p = holeRoh.apply(null, arguments);
      p.then(function (r) {
        offen--; geaendert();
        if (m[2] === "add" || !r.ok || offen || nr !== letzteAenderung || typeof r.json !== "function") return;
        /* Der Aufrufer liest dieselbe Antwort mit r.json() (sein then läuft nach diesem). Einmal lesen und säen, bevor er sie bekommt:
           So steht der Stand, bevor er neu zeichnet und cart-updated meldet (sonst holte der Balken bei schneller Antwort doch /cart.js). */
        /* Aus einer Kopie lesen, damit die Antwort selbst für andere unberührt bleibt (text(), clone() fremder fetch-Hüllen). */
        var g = generation;
        var lauf = r.clone().json().then(function (c) {
          if (g === generation && c && typeof c.item_count === "number" && Array.isArray(c.items)) {
            var stand = {}; for (var k in c) if (k !== "sections") stand[k] = c[k]; /* gerenderte Section nicht mitkopieren */
            saeen(stand);
          }
          return c;
        });
        r.json = function () { return lauf; };
        lauf.catch(function () { /* keine JSON-Antwort: dann holt der nächste Baustein /cart.js */ });
      }, function () { offen--; geaendert(); });
      return p;
    };
  }
  /* Die Meldung cart-updated nach dem Neuzeichnen gehört zur eben gesäten Antwort: Stand behalten (einmal, solange frisch).
     Jede andere Meldung (refreshCart, anderer Tab, Kühltasche) beginnt einen neuen Stand. */
  function gemeldet() {
    if (letzter && letzter.saat && letzter.gen === generation && !offen && Date.now() - letzter.zeit < FRISCH_MS && passtZurListe(letzter.daten)) { letzter.saat = false; return; }
    geaendert();
  }
  /* Behalten nur, wenn die eben gezeichnete Liste genau diesen Warenkorb zeigt (Anzahl und Total im Formular). Sonst kam die Meldung
     von einer anderen Änderung (refreshCart nach einer App, anderer Tab, Liefertermin per update.js ohne Neuzeichnen): neu fragen. */
  function passtZurListe(c) {
    var doc = root.document, f = doc && doc.getElementById("AjaxCartForm");
    var n = f && f.querySelector("[data-cart-count]"), t = f && f.querySelector("[data-cart-total]");
    if (!c || !n || String(c.item_count) !== n.textContent.trim()) return false;
    var z = t ? t.textContent.replace(/[^0-9]/g, "") : "";
    return !z || z === String(c.total_price);
  }
  function kopie(o) { return JSON.parse(JSON.stringify(o)); }
  function holen() {
    var jetzt = Date.now();
    if (!letzter || letzter.gen !== generation || jetzt - letzter.zeit > (letzter.fertig ? FRISCH_MS : HAENGT_MS)) {
      var eintrag = { gen: generation, zeit: jetzt, fertig: false };
      eintrag.p = (holeRoh || root.fetch)("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); });
      eintrag.p.then(function () { if (!eintrag.fertig) { eintrag.fertig = true; eintrag.zeit = Date.now(); } }, function () { if (letzter === eintrag) letzter = null; });
      letzter = eintrag;
    }
    return letzter.p.then(kopie);
  }
  /* Zuerst registriert (diese Datei lädt im Kopf vor den anderen): Jede Meldung beginnt einen neuen Stand, bevor die
     übrigen Hörer (ebenfalls am window, capture) fragen. */
  if (root.addEventListener) root.addEventListener("cart-updated", gemeldet, true);

  /* ---------- Angezeigte Anzahl ---------- */
  var KUEHLTASCHE_VARIANTE = 49512535884062; /* Produkt kuhltasche-1, wie assets/vf-kuehltasche.js und snippets/vf-korb-anzahl.liquid */
  /* /cart.js → Zahl für die Anzeige: item_count ohne die Menge der Kühltasche, nie unter 0; ohne lesbares item_count null. */
  function anzeigeAnzahl(cart) {
    if (!cart || cart.item_count == null || isNaN(Number(cart.item_count))) return null;
    var n = Number(cart.item_count);
    (Array.isArray(cart.items) ? cart.items : []).forEach(function (i) {
      if (i && Number(i.variant_id) === KUEHLTASCHE_VARIANTE) n -= Number(i.quantity) || 0;
    });
    return Math.max(0, n);
  }

  var api = { STANDARD: STANDARD, aus: aus, lesen: lesen, holen: holen, anzeigeAnzahl: anzeigeAnzahl, KUEHLTASCHE_VARIANTE: KUEHLTASCHE_VARIANTE };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else root.VFWarenkorbBasis = api;
})(typeof window !== "undefined" ? window : globalThis);
